// import { UserInfo } from '@/context/PageStateContext';
import { mediaClient } from "@/lib/request";


/**
 * 登陆信息响应数据
 */
export interface UserInfoData {
    userInfo: {
        userId: number;
        token: string;
        uuid: string;
        isLogin: boolean;
        isLoginExpired: boolean;
    }
  }

/**
 * 登陆信息接口
 */
export async function getUserInfo() {
    return mediaClient.post<UserInfoData>({
        url: "/fulishemini/lianmeng/user",

      });
}